export default {
  getCommonTextSettings: function () {
    return {
      fontFamily: 'sans-serif',
      fontSize: 14,
      fontWeight: 300,
      align: 'center',
      fill: '#00000066',
      listening: false,
    }
  },
  isValidTriangle: function (a: number, b: number, c: number) {
    let isValid = true
    if (a + b <= c || a + c <= b || b + c <= a) {
      isValid = false
    }
    return isValid
  },
  getTriangleVerticeCoordinates: function (a: number, b: number, c: number) {
    // Calculate the coordinates using the side lengths
    const x = (c * c - b * b + a * a) / (2 * a)
    const y = Math.sqrt(c * c - x * x)

    return { x: x, y: y }
  },
}
